import type { SVGProps } from 'react';

const SvgCopyBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M16 16H19.5C20.0523 16 20.5 15.5523 20.5 15V4.5C20.5 3.94772 20.0523 3.5 19.5 3.5H9C8.44772 3.5 8 3.94772 8 4.5V8M4.5 20.5H15C15.5523 20.5 16 20.0523 16 19.5V9C16 8.44772 15.5523 8 15 8H4.5C3.94772 8 3.5 8.44772 3.5 9V19.5C3.5 20.0523 3.94772 20.5 4.5 20.5Z'
      stroke='currentColor'
      strokeWidth={2}
    />
  </svg>
);
export default SvgCopyBd;
